export default {
  ActivityLogImportJob: 'Uvoz dnevnika aktivnosti',
  AllSurveysDataMigrationJob: 'Migracija podataka svih istraživanja',
  ArenaMobileDataImportJob: 'Uvoz podataka iz Arena',
  ArenaMobileDataImportSummaryJob: 'Sažetak uvoza podataka iz Arena',
  CategoriesImportJob: 'Uvoz kategorija',
  CategoriesValidationJob: 'Validacija kategorija',
  CategoriesBatchImportJob: 'Uvoz kategorija',
  CategoryImportJob: 'Uvoz kategorije',
  CategoryImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryValidationJob: 'Validacija kategorije',
  ChainsCyclesCheckJob: `Provjera ciklusa lanaca obrade`,
  ChainsSamplingNodeDefsCheckJob: 'Kreiranje definicija čvorova uzorka za lance obrade',
  ChainsValidationJob: 'Validacija lanaca obrade',
  ChainsImportJob: 'Uvoz lanaca obrade',
  CollectDataImportJob: 'Uvoz podataka iz Collect',
  CollectImportJob: 'Uvoz iz Collect',
  CollectSurveyReaderJob: 'Čitanje Collect istraživanja',
  CyclesDeletedCheckJob: 'Provjera obrisanih ciklusa',
  DataDeleteJob: 'Brisanje podataka',
  DataImportJob: 'Uvoz podataka',
  DataImportValidationJob: 'Validacija fajla za uvoz podataka',
  EntitiesDeleteJob: 'Brisanje postojećih entiteta',
  FilesImportJob: 'Uvoz fajlova',
  MessageSendJob: 'Slanje poruke',
  NodeDefsTranslationJob: 'Prevod oznaka definicija čvorova',
  NodeDefsImportJob: 'Uvoz definicija čvorova',
  NodeDefsValidationJob: 'Validacija definicija čvorova',
  OdkImportJob: 'Uvoz iz ODK',
  OdkDataImportJob: 'Uvoz podataka iz ODK',
  OdkFormReaderJob: 'Čitanje ODK obrasca',
  OdkSubmissionReaderJob: 'Čitanje ODK podnesaka',
  RecordCheckJob: 'Provjera zapisa',
  RecordsCloneJob: 'Kloniranje zapisa',
  RecordsImportJob: 'Uvoz zapisa',
  RecordsImportSummaryJob: 'Sažetak uvoza zapisa',
  RecordsUniquenessValidationJob: 'Validacija jedinstvenosti zapisa',
  SamplingPointDataImportJob: 'Uvoz podataka o tačkama uzorka',
  SamplingPointDataImportInternalJob: 'Uvoz podataka o tačkama uzorka',
  SchemaSummaryExportJob: 'Izvoz sažetka šeme',
  SelectedRecordsExportJob: 'Izvoz izabranih zapisa',
  SurveyActivityLogClearJob: 'Brisanje dnevnika aktivnosti istraživanja',
  SurveyCreatorJob: 'Kreiranje istraživanja',
  SurveyDataMigrationJob: 'Migracija podataka istraživanja',
  SurveyDependencyGraphsGenerationJob: 'Generisanje grafa zavisnosti istraživanja',
  SurveyExportJob: 'Izvoz istraživanja',
  SurveyCompareJob: 'Poređenje istraživanja',
  SurveyCompareDiffJob: 'Izračunavanje razlika',
  SurveyCompareApplyJob: 'Primjena izmjena istraživanja',
  SurveyFilesImportJob: 'Uvoz fajlova istraživanja',
  SurveyIndexGeneratorJob: 'Generisanje indeksa istraživanja',
  SurveyInfoValidationJob: 'Validacija informacija o istraživanju',
  SurveyLabelsImportJob: 'Uvoz oznaka istraživanja',
  SurveyPropsPublishJob: 'Objavljivanje svojstava istraživanja',
  SurveyPublishJob: 'Objavljivanje istraživanja',
  SurveyPublishPerformJob: 'Izvršavanje objavljivanja istraživanja',
  SurveyRdbCreationJob: 'Kreiranje RDB istraživanja',
  SurveyRdbSchemaCreationJob: 'Kreiranje RDB šeme istraživanja',
  SurveyRdbDataTablesAndViewsCreationJob: 'Kreiranje RDB tabela podataka i pogleda istraživanja',
  SurveyRdbOlapDataTablesCreationJob: 'Kreiranje RDB OLAP tabela podataka istraživanja',
  SurveyUnpublishJob: 'Poništavanje objave istraživanja',
  SurveyPropsUnpublishJob: 'Poništavanje objave svojstava istraživanja',
  SurveysListExportJob: 'Izvoz liste istraživanja',
  SurveysRdbRefreshJob: 'Osvježavanje RDB istraživanja',
  TaxonomiesImportJob: 'Uvoz taksonomija',
  TaxonomiesValidationJob: 'Validacija taksonomija',
  TaxonomyImportJob: 'Uvoz taksonomije',
  UsersBackupExportJob: 'Rezervna kopija korisnika',
  UsersBackupImportJob: 'Vraćanje korisnika',
  // data export
  ArenaFileReadJob: 'Čitanje Arena fajla',
  DataExportJob: 'Izvoz podataka',
  DataMatrixExportJob: 'Izvoz matrice podataka',
  DataSummaryExportJob: 'Izvoz sažetka podataka',
  ZipCreationJob: 'Kreiranje ZIP fajla',
  CSVDataExtraction: 'Izdvajanje podataka',
  FilesExportJob: 'Izvoz fajlova',
  PrepareImportFileJob: 'Priprema fajla za uvoz',
  // geo
  GeoJsonDataExportJob: 'Izvoz podataka u GeoJson',
  // import arena survey
  ArenaImportJob: 'Uvoz iz Arena',
  ArenaSurveyReaderJob: 'Čitanje Arena istraživanja',
  CreateRdbJob: 'Kreiranje RDB istraživanja',
  UsersImportJob: 'Uvoz korisnika',
  // clone survey
  SurveyCloneJob: 'Kloniranje istraživanja',
  CloneSurveyJob: 'Kloniranje istraživanja',
  // survey backup
  SurveyInfoExportJob: 'Izvoz informacija o istraživanju',
  CategoriesExportJob: 'Izvoz kategorija',
  CategoryGeoPackageExportJob: 'Izvoz kategorije u GeoPackage',
  SamplingPointDataWhispJob: 'Whisp analiza podataka o tačkama uzorka',
  SamplingPointDataWhispAnalysisJob: 'Whisp analiza',
  SamplingPointDataWhispCategoryImportJob: 'Uvoz Whisp kategorije',
  TaxonomiesExportJob: 'Izvoz taksonomija',
  RecordsExportJob: 'Izvoz zapisa',
  RecordFilesExportJob: 'Izvoz fajlova zapisa',
  SurveyFilesExportJob: 'Izvoz fajlova istraživanja',
  ChainExportJob: 'Izvoz lanca obrade',
  UsersExportJob: 'Izvoz korisnika',
  ActivityLogExportJob: 'Izvoz dnevnika aktivnosti',
  InfoExportJob: 'Generisanje informacija o izlaznom fajlu',
  // validation Report
  VaidationReportGenerationJob: 'Generisanje izvještaja o validaciji',
  // record Validation
  RecordsValidationJob: `Validacija zapisa`,
  // analysis
  PersistResultsJob: 'Čuvanje rezultata analize',
  PersistOlapDataJob: 'Čuvanje OLAP podataka',
}
